module.exports = __webpack_public_path__ + "static/media/mode-41.94765c8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-41.svg
// module id = 1014
// module chunks = 2